import { render, staticRenderFns } from "./SmallVariant.vue?vue&type=template&id=47e4d520&"
import script from "./SmallVariant.vue?vue&type=script&lang=js&"
export * from "./SmallVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports